"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cermenate": {
    "f7ad473b": [{
      "hkey": "690524ff",
      "slug": "cermenate",
      "name": "Cermenate",
      "primary": true,
      "skipSearch": false
    }],
    "asnago": [{
      "hkey": "690524ff",
      "slug": "cermenate",
      "name": "Cermenate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fe9d13db": [{
      "hkey": "690524ff",
      "slug": "cermenate",
      "name": "Cermenate",
      "primary": true,
      "skipSearch": false
    }],
    "borgate-permonte": [{
      "hkey": "690524ff",
      "slug": "cermenate",
      "name": "Cermenate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8aae5328": [{
      "hkey": "690524ff",
      "slug": "cermenate",
      "name": "Cermenate",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-lavezzari": [{
      "hkey": "690524ff",
      "slug": "cermenate",
      "name": "Cermenate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6f5b43ae": [{
      "hkey": "690524ff",
      "slug": "cermenate",
      "name": "Cermenate",
      "primary": true,
      "skipSearch": false
    }],
    "castello": [{
      "hkey": "690524ff",
      "slug": "cermenate",
      "name": "Cermenate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cc7e5407": [{
      "hkey": "690524ff",
      "slug": "cermenate",
      "name": "Cermenate",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "690524ff",
      "slug": "cermenate",
      "name": "Cermenate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "75db154f": [{
      "hkey": "690524ff",
      "slug": "cermenate",
      "name": "Cermenate",
      "primary": true,
      "skipSearch": false
    }],
    "freghera": [{
      "hkey": "690524ff",
      "slug": "cermenate",
      "name": "Cermenate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "10d769ae": [{
      "hkey": "690524ff",
      "slug": "cermenate",
      "name": "Cermenate",
      "primary": true,
      "skipSearch": false
    }],
    "montesordo": [{
      "hkey": "690524ff",
      "slug": "cermenate",
      "name": "Cermenate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "07e431af": [{
      "hkey": "690524ff",
      "slug": "cermenate",
      "name": "Cermenate",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria-in-campo": [{
      "hkey": "690524ff",
      "slug": "cermenate",
      "name": "Cermenate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;